import { Injectable, EventEmitter } from '@angular/core';
import { SignalRService, SignalREventService, Preset, PresetDocument, DataArray, GlobalService, ToastrService } from './../index';

@Injectable()
export class PresetService {
    public beginFilter: EventEmitter<boolean> = new EventEmitter<boolean>();
    public presetChange: EventEmitter<Preset[]> = new EventEmitter<Preset[]>();
    public filteredPresetsChange: EventEmitter<Preset[]> = new EventEmitter<Preset[]>();
    public showDetailsChange: EventEmitter<Preset> = new EventEmitter<Preset>();
    public presetDocuments: EventEmitter<PresetDocument[]> = new EventEmitter<PresetDocument[]>();

    public manipulatePreset: EventEmitter<Preset> = new EventEmitter<Preset>();

    public presetSelectedChange: EventEmitter<number> = new EventEmitter<number>();
    public presetSelectionReset: EventEmitter<void> = new EventEmitter<void>();


    public presets: DataArray<Preset> = new DataArray<Preset>();
    private filteredPresets: DataArray<Preset> = new DataArray<Preset>(1);
    private filterApplied = false;
    private search = '';
    private selectedPresets = 0;
    public totalPresets = 0;
    constructor(
        private _signalRService: SignalRService,
        private _signalREventService: SignalREventService,
        private _GlobalService: GlobalService,
        private _toastrService: ToastrService
    ) {
        this.registerOnServerEvents();
    }

    public setFilter(search: string, selectedPreset: number): void {
        if (search != '' || selectedPreset != 0) {
            this.selectedPresets = selectedPreset;
            this.search = search;
            this.filterApplied = true;
        }
    }

    public clearFilter(): void {
        this.search = ''
        this.selectedPresets = 0;
        this.filterApplied = false;
    }

    public ResetPresetSelection(): void {
        this.presetSelectionReset.emit();
    }

    public getPresets(): void {
        this._signalRService.invoke('GetPresets');
    }

    public showDetails(preset: Preset): void {
        this.showDetailsChange.emit(preset);
    }

    public manipulate(preset: Preset): void {
        this.manipulatePreset.emit(preset);
    }

    public create(presetName: string): void {
        this._signalRService.invoke('CreatePreset', presetName);
    }

    public DeletePreset(presetId: number): void {
        this._signalRService.invoke('DeletePreset', presetId);
    }

    public ClonePreset(presetId: number, newPresetName: string): void {
        this._signalRService.invoke('ClonePreset', presetId, newPresetName);
    }

    public DeletePresetDocument(presetId: number, documentId: number): void {
        this._signalRService.invoke('DeletePresetDocument', presetId, documentId, false);
    }

    public getPresetDocuments(presetId: number, resetSelectedDocument: boolean): void {
        this._signalRService.invoke('GetDocumentsForPreset', presetId, resetSelectedDocument);
    }

    public applyFilter(): void {
        this._signalRService.invoke('FilterPresets', this.search, this.selectedPresets);
    }

    public getFilteredPresets(presetId: string): void {
        this._signalRService.invoke('FilterPresets', presetId);
    }

    private onPresets(info: any): void {
        this.totalPresets = info.Data.Total;
        this.presets = new DataArray<Preset>();
        for (const item of info.Data.Presets) {
            const preset: Preset = $.extend(new Preset(), item);
            preset.documentsVisible = !(info.Data.currentPresetId == -1);
            this.presets.push(preset);
        }
        this.presetChange.emit(this.presets.Data);
    }

    private onPresetDocuments(info: any): void {
        this.presetDocuments.emit(info.Data);
        this.presetSelectedChange.emit(info.Data);
    }

    private onFilteredPresets(info: any): void {
        this.totalPresets = info.Data.Total;
        this.filteredPresets = new DataArray<Preset>();
        for (const item of info.Data.Presets) {
            const preset: Preset = $.extend(new Preset(), item);
            this.filteredPresets.push(preset);
        }

        this.filteredPresetsChange.emit(this.filteredPresets.Data);
    }

    public associateDocumentsToPreset(presetId: number, documentIds: number[]): void {
        this._signalRService.invoke('AssociateDocumentsToPreset', presetId, documentIds, false);
    }

    public selectPreset(presetId: number): void {
        this.getPresetDocuments(presetId, true);
    }

    private registerOnServerEvents() {
        this._signalREventService.register('PresetService', 'presets', (info: any) => this.onPresets(info));
        this._signalREventService.register('PresetService', 'beginRecievePresets', () => { this.presets.init(); });
        this._signalREventService.register('PresetService', 'presetDocuments', (info: any) => this.onPresetDocuments(info));
        this._signalREventService.register('PresetService', 'beginRecieveFilteredPresets', () => { this.beginFilter.emit(true); this.filteredPresets.init() });
        this._signalREventService.register('PresetService', 'filteredPresets', (info: any) => this.onFilteredPresets(info));
    }

    public deregisterOnServerEvents(): void {
        this._signalREventService.deregister('PresetService');
    }
}
